var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWidgetIconV25Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00098 4.94026L1.53039 0.469666L0.469727 1.53033L4.94032 6.00092L0.471566 10.4697L1.53223 11.5303L6.00098 7.06158L10.4697 11.5303L11.5304 10.4697L7.06164 6.00092L11.5322 1.53033L10.4716 0.469666L6.00098 4.94026Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWidgetIconV25Dark);
export default __webpack_public_path__ + "static/media/close-widget-icon-v2.5-dark.0efbf040b665ff7b2b4703103682e77c.svg";
export { ForwardRef as ReactComponent };